<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table ref="table" v-model="selected" pagination search :max-items="itemsPerPage" :data="listCompanies">
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<div class="flex flex-wrap-reverse items-center data-list-btn-container">
					<vs-button
						type="filled"
						class="g-btn-customize p-0 btnCustom"
						icon-pack="feather"
						icon="icon-plus"
						@click.prevent="$emit('valueCreateCompany', 1)"
					>
						<span class="btnTextCustom">{{ $t("Crud.Create") + " " + $t("NewCompany") }}</span>
					</vs-button>
				</div>
			</div>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<company-list-view-item
							:item="tr"
							:editData="editData"
							:openConfirm="openConfirm"
							:createAdminResource="createAdminResource"
							:createServiroute="createServiroute"
						></company-list-view-item>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleCompany from "@/store/company/moduleCompany.js";
import Company from "@/models/Company.js";
import CompanyListViewItem from "./CompanyListViewItem.vue";

export default {
	name: "CompanyListView",
	components: {CompanyListViewItem},
	data() {
		return {
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
		};
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		listCompanies() {
			return [...this.$store.state.moduleCompany.companies].reverse();
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listCompanies.length;
		},
		totalCompanies() {
			return this.$store.getters["moduleCompany/totalCompanies"];
		},
	},
	methods: {
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteCompany"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		deleteData(id) {
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/removeItem", id)
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyDelete"),
						text: this.$t("TextConfirmCompanyDelete"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		editData(data) {
			this.$emit("selectedCompanyEmit", new Company(data), "update");
		},
		createAdminResource(data) {
			this.$emit("selectedCompanyCreateAdminResourceEmit", data, "createAdmin");
		},
		createServiroute(data) {
			this.$emit("selectedCompanyCreateServirouteEmit", data, "createServiroute");
		},
		getOrderStatusColor(status) {
			if (status === "on_hold") return "warning";
			if (status === "delivered") return "success";
			if (status === "canceled") return "danger";
			return "primary";
		},
		getPopularityColor(num) {
			if (num > 90) return "success";
			if (num > 70) return "primary";
			if (num >= 50) return "warning";
			if (num < 50) return "danger";
			return "primary";
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
	},
	created() {
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		this.openLoading();
		this.$store
			.dispatch("moduleCompany/fetchDataListItems")
			.then((res) => {
				this.closeLoading();
			})
			.catch((err) => {
				this.closeLoading();
				throw new Error(err);
			});
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
